import { login } from '@/utils/api';
import { PLAT_TYPE } from '@/utils/constant';

export const loginModule = {
  data () {
    return {
      imageCodeData: {},
      second: { value: 0 },
      isReclick: false
    };
  },
  methods: {
    /** 获取图片验证码 */
    getImageCode () {
      this._get({
        url: login.imgCaptcha,
        params: {}
      }).then(({ data }) => {
        this.imageCodeData = data;
      });
    },
    /** 获取手机验证码 */
    getCaptcha (phone, type, captchaVerification) {
      let that = this;
      if (this.isReclick) {
        return;
      } else {
        this.isReclick = true;
        setTimeout(() => {
          that.isReclick = false;
        }, 1000);
      }
      return new Promise((resolve, reject) => {
        if (this.second.value > 0) {
          this.$message.error('操作过于频繁,请稍后再试');
          return;
        }

        this._get({
          url: '/userLogin/getSmsCode',
          params: {
            phone,
            type: type, // 0忘记密码  1修改密码  2认证(微信绑定手机) 3登录 4注册
            platType: PLAT_TYPE,
            isVoice: '2', // 是否语言验证码, 1: 语音验证码 2: 短信验证码
            captchaVerification
          },
          btnLoading: this.btnLoading
        }).then((res) => {
          this.$message.success(res.msg);
          this.countDown(this.second);
          resolve(true);
        }).catch((err) => {
          const response = err.data;
          if (response.code === 30011) {
            resolve(response.code);
          }
        });
      });
    }
  }
};
